<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h14">Agradecimientos</h1>
<p class="p9"><img alt="img2.png" src="images/img2.png"/></p>
<p> </p>
<p class="p9"><span class="t7">H</span><span class="t8">ACE</span><span class="t7"> </span>como mil años, después de conseguir mi título de profesora, mi madrastra me llevó de compras en busca de un conjunto que llevar a las entrevistas. En un momento dado salí del vestidor y enseguida, Janis, mi madrastra, empezó a ajustarme el sujetador, a subirme los calcetines y ponerlo todo en orden mientras yo estaba allí sentada pasivamente bajo la mortificación filial. Tras un momento Janis se dio cuenta de lo que estaba haciendo y de que yo tenía veintitrés años y no ocho. </p>
<p>—Lo siento; date cuenta de que cuando tengas sesenta años y yo ochenta,  seguiré todavía ajustándote los calcetines —dijo.</p>
<p>Mi madrastra se ha convertido en la defensora de los ancianos en mi hogar. Enfermera de la UCI, se ha ocupado de los últimos asuntos y de las necesidades médicas de la madre de mi padre, de la madre de su ex marido y de su propia madre. Les ha acompañado en sus últimos momentos.</p>
<p>Es un milagro cuanto menos.</p>
<p>Me ha enseñado todo en lo que creo sobre la vida, la muerte y sobre la amabilidad y la dignidad que tienen ambas. Si hay algo, por poco que sea, que te emocione en la relación entre Mikhail y Ylena, hay que agradecérselo a ella.</p>
<p>Ya era hora de que yo lo hiciese.</p>
<p>Gracias, Janis. Chica, tuve suerte.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?6c5e2e4c